import { useState } from 'react';
import { toast } from 'react-toastify';
import { FaPencilAlt } from 'react-icons/fa';

interface Props {
    value: string;
    maxLength: number;
    onSave: (val: string) => Promise<void>;
}

export default function EditableTextField({ value, maxLength, onSave }: Props) {
    const [editing, setEditing] = useState(false);
    const save = async (raw: string) => {
        setEditing(false);
        const trimmed = raw.trim().slice(0, maxLength);
        if (trimmed === (value || '')) return;
        try { await onSave(trimmed); } catch { toast.error('Erro ao salvar'); }
    };
    if (editing) {
        return (
            <textarea
                autoFocus
                defaultValue={value || ''}
                maxLength={maxLength}
                rows={2}
                onBlur={(e) => save(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Escape') setEditing(false); }}
                className="w-full px-1 py-0.5 text-xs border border-blue-400 rounded bg-white dark:bg-slate-700 dark:text-gray-100 focus:outline-none resize-none"
            />
        );
    }
    return (
        <span onClick={() => setEditing(true)} className="flex items-center gap-1 w-full h-full min-h-[24px] dark:text-gray-200 cursor-pointer hover:text-blue-700 dark:hover:text-blue-300 hover:bg-blue-100 dark:hover:bg-blue-900/40 rounded px-1 border border-transparent hover:border-blue-300 dark:hover:border-blue-600 max-w-[200px] text-xs" title={value || 'Clique para editar'}>
            <span className="truncate flex-1">{value || '-'}</span>
            <FaPencilAlt className="text-[9px] text-gray-400 shrink-0" />
        </span>
    );
}
